import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0zm3.342 9.75H9.75v6.011l.042-.053c1.535-2.008 2.38-3.992 2.55-5.958zm-8.025 0H1.914a7.132 7.132 0 0 0 4.592 5.926c-1.308-1.958-2.042-3.935-2.189-5.926zm11.769 0h-2.239c-.145 1.961-.859 3.91-2.13 5.84a7.133 7.133 0 0 0 4.369-5.84zm-7.836 0H5.822c.167 1.914.97 3.843 2.427 5.796L8.25 9.75zM6.506 2.323l-.016.007a7.132 7.132 0 0 0-4.576 5.92h2.403c.147-1.99.88-3.967 2.189-5.927zm3.244-.086V8.25h2.592c-.172-1.982-1.029-3.982-2.588-6.008l-.004-.005zm1.967.174.216.337c1.137 1.82 1.778 3.656 1.914 5.503h2.239a7.131 7.131 0 0 0-4.369-5.84zm-3.468.044C6.792 4.408 5.99 6.337 5.822 8.25H8.25z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "globe"}) } }